var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex", attrs: { id: "analytics-base" } }, [
    _c(
      "div",
      {
        staticClass:
          "analytics-panel fixed left-0 z-50 w-60 flex-shrink-0 bg-pure-white border-r border-slate-400 overflow-y-auto",
        attrs: { id: "analytics-panel" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "sticky top-0 z-10 h-24 px-6 flex items-center bg-pure-white border-b border-slate-400"
          },
          [_c("BlTextTitle3", { attrs: { text: "Analytics" } })],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex-col gap-1 px-3 py-1 pb-16" },
          _vm._l(_vm.tabs, function(tab, idx) {
            return _c(
              "div",
              { key: idx },
              [
                !tab.target
                  ? _c("div", { staticClass: "flex flex-col gap-1" }, [
                      tab.divider
                        ? _c("div", {
                            staticClass: "h-0.5 my-1 w-full bg-slate-300"
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "px-3" },
                        [
                          _c("BlTextBody3", {
                            staticClass: "text-slate-600",
                            attrs: { text: tab.label }
                          })
                        ],
                        1
                      )
                    ])
                  : _c(
                      "router-link",
                      {
                        staticClass:
                          "relative p-3 flex items-center gap-2 rounded transition-all duration-300",
                        class: [
                          tab.isActive ? "bg-slate-300" : "hover:bg-hover-state"
                        ],
                        attrs: { to: tab.target, title: tab.label }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "h-4 w-4",
                          attrs: { icon: tab.icon, color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlTextSubtitle3", {
                          staticClass: "truncate",
                          attrs: { text: tab.label }
                        })
                      ],
                      1
                    )
              ],
              1
            )
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "pl-60 flex flex-col flex-grow",
        attrs: { id: "analytics-body" }
      },
      [
        !_vm.paramsTab && !_vm.searchParams["branch"]
          ? _c("CenterOverview")
          : _vm._e(),
        _vm._v(" "),
        !_vm.paramsTab && _vm.searchParams["branch"]
          ? _c("BranchOverview", {
              key: "branch-overview-" + _vm.searchParams["branch"]
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "acquisition-overview"
          ? _c("AcquisitionOverview")
          : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "acquisition-comparison"
          ? _c("AcquisitionComparison")
          : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "client-turnover" ? _c("ClientTurnover") : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "team-turnover" ? _c("TeamTurnover") : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "team-performance" ? _c("TeamPerformance") : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "appointment-overview"
          ? _c("AppointmentOverview")
          : _vm._e(),
        _vm._v(" "),
        _vm.paramsTab === "cancellation-overview"
          ? _c("CancellationOverview")
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-027a13bd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027a13bd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analytics/Analytics.vue
// module id = null
// module chunks = 